var $ = jQuery;

import Swiper from 'swiper';

$(document).on('ready', function(){
    if($('.video-swiper').length){
      $('.video-swiper').each(function(index){
          new Swiper($(this)[0], {
          slidesPerView: 1.2,
          mousewheelControl: true,
          loop: false,
          spaceBetween: 20,
          slidesOffsetAfter: 200
        });
      });
    }
    $(document).on('click', '.video-play', function() {
      var index = $(this).attr('index');
      $('.video-post').each(function(i, obj) {
        if(obj.getAttribute('index') == index) {
          if (obj.paused || obj.ended) {
            obj.play();
            $('.video-btn').each(function(i, obj) {
              if(obj.getAttribute('index') == index) {
                $(obj).text('pause');
              }
            })
          } else {
            obj.pause();
            $('.video-btn').each(function(i, obj) {
              if(obj.getAttribute('index') == index) {
                $(obj).text('play');
              }
            })
          }
        }
      })
    })
  });
